import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import NewsCard from '../components/Home/NewsCard';
import Sidebar from '../components/Home/Sidebar';
import { useApp } from '../context/AppContext';

const SearchPage = () => {
    const [searchParams] = useSearchParams();
    const query = searchParams.get('q') || '';
    const { articles } = useApp();
    const [results, setResults] = useState([]);

    useEffect(() => {
        if (query) {
            const filtered = articles.filter(a =>
                a.status === 'live' && (
                    a.title.toLowerCase().includes(query.toLowerCase()) ||
                    a.content?.toLowerCase().includes(query.toLowerCase()) ||
                    a.tags?.toLowerCase().includes(query.toLowerCase()) ||
                    a.category.toLowerCase().includes(query.toLowerCase())
                )
            );
            setResults(filtered);
        }
    }, [query, articles]);

    return (
        <div className="page">
            <div className="two-col">
                <div>
                    <div className="section-title">Search Results for "{query}"</div>
                    <div className="three-col">
                        {results.map(article => (
                            <NewsCard key={article._id} article={article} />
                        ))}
                    </div>
                    {results.length === 0 && (
                        <p style={{ textAlign: 'center', padding: '40px', color: '#888' }}>No results found for "{query}"</p>
                    )}
                </div>
                <div>
                    <Sidebar articles={articles} />
                </div>
            </div>
        </div>
    );
};

export default SearchPage; ``